module.exports = __webpack_public_path__ + "img/photo-flow1.4c632880.png";